<div class="modal-content modalContent modal">
  <div class=" modalHeader" style="text-align: center;">
    <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
    <h4 style="font-size: 19px; padding-top: 12px; font-weight: 700;" class="modal-title"><i class="fa fa-warning"></i> Disclaimer</h4>
  </div>
  <div class="modal-body" style="scroll-behavior: smooth;overflow: scroll;">


    <div class="disclaimer-text" style="font-size: 12px; line-height: 16px; text-align: justify;">

      <p class="para">
        <span style="font-weight: 700;font-size: 14px; text-align: center;display: block;">Please read the Terms of Use
          carefully before you start to use the Application.</span>
        <br> <br>
        <span
          style="font-weight: 700;font-size: 14px; text-align: center;display: block;    text-decoration: underline;">Terms
          of Use - Application</span>
        <br>
        <span style="font-size: 14px;text-align: justify;display: block;font-family: Calibri;">
          This application may contain sensitive and personal information governed by Privacy laws including but not
          limited to Health Insurance Portability and Accountability Act. By using the Application, you accept and agree
          to abide and be bound by all the applicable privacy and governing laws, and the below mentioned Terms of Use
          along with the ‘terms & conditions’ signed in the MSA, BAA and SOW with client.
          <br> <br>
          By using this Application, you represent and warrant that you are of legal age to form a binding contract with
          us i.e. GeBBS Healthcare Solutions Inc., its subsidiaries, affiliates and assigns.
          <br> <br>
        </span>
        <span
          style="font-weight: 700;font-size: 14px; text-align: Left;display: block;    text-decoration: underline;">User
          Conduct:</span>
        <br>
        <span style="font-size: 14px;text-align: justify;display: block;font-family: Calibri;">
          You agree to use the application only for lawful purpose with your own ID and password; and not to use the
          application for:
        </span>
      <ul>
        <span style="font-size: 14px;text-align: justify;display: block;font-family: Calibri;">
          <li>any illegal or unethical purpose or in any way that could damage, disable, overburden, or impair the
            application or hosting site</li>
          <li>license, sublicense, sell, resell, transfer, assign, distribute or otherwise commercially exploit or make
            available to any third party the Service or Materials or any rights in any way</li>
          <li>reverse engineer the Service or Materials or access the Service or Materials in order to build a
            competitive
            product or service</li>
          <li>use a Service or Software to store or transmit infringing, libelous, or otherwise unlawful or tortious
            material, or to store or transmit material in violation of third-party privacy rights</li>
          <li>Transmit or display any individually identifiable health information except as approved by GeBBS;</li>
          <li>Collect personal data (including contact information) about other users for mass marketing, or
            solicitation
            purposes, except the intended purpose as agreed with GeBBS </li>
          <li>Use or attempt to use another user's account or password;</li>
          <li>Post, host, display, upload, modify, publish, transmit, store, update or share or display any material or
            information that:</li>
          <ul>
            <li>belongs to another person or on which you have no right; </li>
            <li>is obscene, pornographic, pedophilic, invasive of another’s privacy including bodily privacy, insulting
              or
              harassing on the basis of gender, racially or ethnically objectionable, relating or encouraging money
              laundering or gambling, online game that causes harm, promoting enmity between different groups on ground
              of
              religion or caste with the intent to incite violence;</li>
            <li>is harmful to children; </li>
            <li>infringes any patent, trademark, copyright or other proprietary rights, etc.; </li>
            <li>impersonates another person; </li>
            <li>threatens the unity, integrity, defense, security or sovereignty of India, friendly relations with
              foreign States, or public order, or causes incitement to the commission of any cognizable offence, or
              prevents investigation of any offence, or is insulting other nation;
              is false, disparaging, or otherwise objectionable in GeBBS's discretion; </li>
            <li>is false, disparaging, or otherwise objectionable in GeBBS's discretion;</li>
            <li>contains any malicious code, viruses, Trojan horses, worms, logic bombs, automated use of the
              Application,
              computer code, file or program designed to interrupt, destroy or limit the functionality of any computer
              resource etc., any component that inhibits any other user's use or enjoyment of the Application, or
              disables
              or disrupts the Application or any equipment or software connected;</li>
            <li>is in the nature of an online game that is not verified as a permissible online game;</li>
            <li>contains misleading indications of the origin of any content transmitted to the Application ;</li>
            <li>solicits personnel recruitment or constitutes advertising, junk mail, or any form of solicitation; or
            </li>
          </ul>
          <li>Assist anyone in doing the above-mentioned prohibited conduct </li>
        </span>
      </ul>
      <span style="font-size: 14px;text-align: justify;display: block;font-family: Calibri;">
        If you have any questions, grievances or concerns about these Terms of Use and Privacy Policy or you need to
        report any unauthorized use of the application or any incident - please contact us at <a href="mailto:compliance@gebbs.com">compliance&#64;gebbs.com</a>.
        Your queries will be managed by our CRCO and CISO. For details, refer the <a target=”_blank” href="https://gebbs.com/about-us/#leadership-team">Leadership section</a>.
        Please refer our Privacy Policy by  <a target=”_blank” href="https://gebbs.com/privacy-policy/">clicking here</a>
        <br>
        If you have face any technical issue, please get in touch with our Technical Support representative.
      </span>
        <br> <br>

       <span style="font-size: 14px;text-align: justify;display: block;font-family: Calibri;font-weight: 700;">
        Intellectual Property Rights, Disclaimer of Warranties, Limitation of Liability and Governing Law:
        </span>
        <br>
        Kindly refer the agreed terms & conditions as per the Master Service Agreement, Business Associate Agreement,
        Non-Disclosure Agreement and Scope of Work signed with the client.
        <br> <br>
       <span style="font-size: 14px;text-align: justify;font-family: Calibri;font-weight: 700;">
        Changes to Terms:
        </span>
        We reserve the right to modify these Terms of Use and Privacy Policy at any time, and will
        notify you of any such changes or modification by means of either email notifications, pop-ups, blinking
        notifications on the webpages or in-app notifications. Your continued use of the application or website after
        any such changes constitutes your acceptance of the new Terms of Use and Privacy Policy. GeBBS further reserves
        the right to stop providing the Services (or any features within the Services) to you or to Users generally,
        including by suspending your account, at GeBBS's sole discretion, without prior notice.
        <br> <br>


      <span style="font-size: 14px;text-align: justify;display: block;font-family: Calibri;">
        Last Updated: June 20, 2024
      </span>




    </div>
  </div>
  <div class="modal-footer" style="display: inline;">
    <button type="button" class="btn btn-rounded btn-primary" (click)="Accept()"
      style="margin-left:45%;font-size: 1.3rem;" data-dismiss="modal">Accept
    </button>
  </div>
</div>
